import { render, staticRenderFns } from "./EventViewPage.vue?vue&type=template&id=00e373a6&"
import script from "./EventViewPage.vue?vue&type=script&lang=js&"
export * from "./EventViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports